<template>
  <div id="schedule-availability">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
          <vx-card>
            <vs-row vs-w="12" class="mb-10">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="1"
                vs-sm="4"
                vs-xs="12"
              >
                <vs-button
                  @click="goBack"
                  color="danger"
                  type="border"
                  icon="keyboard_backspace"
                  >Back</vs-button
                >
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="9"
                vs-sm="4"
                vs-xs="12"
              >
                <h3>Schedule Availability</h3>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="2"
                vs-sm="4"
                vs-xs="12"
              >
              </vs-col>
            </vs-row>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Single Date</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-radio v-model="schedule_type" vs-value="single_date"
                  ><span class="ml-5"> </span
                ></vs-radio>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Continuous Date</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-radio v-model="schedule_type" vs-value="continuous_date"
                  ><span class="ml-5"></span
                ></vs-radio>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Multiple Non Continuous Date</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-radio
                  v-model="schedule_type"
                  vs-value="multiple_non_continuous_date"
                  ><span class="ml-5"></span
                ></vs-radio>
              </div>
            </div>

            <vs-divider class="p-5" />
            <form>
              <div class="vx-row pb-20" v-if="schedule_type == 'single_date'">
                <div class="vx-col sm:w-1/5 w-full">
                  <h5>Schedule Single Date</h5>
                </div>
                <div class="vx-col  sm:w-1/2 w-full">
                  <vs-radio
                    v-model="single_date.availability"
                    vs-value="available"
                    class="mr-5"
                    >Available</vs-radio
                  >
                  <vs-radio
                    v-model="single_date.availability"
                    vs-value="not-available"
                  >
                    Not Available</vs-radio
                  >

                  <div class="vx-row mt-10">
                    <div class="vx-col sm:w-1/6 w-full">
                      <span>Choose Date</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                      <flat-pickr
                        :config="configdatePicker"
                        v-model="single_date.date"
                        placeholder="Choose Date Time"
                        name="single_date_date"
                        v-validate="'required'"
                        data-vv-as="Date"
                      />
                    </div>

                    <vs-checkbox
                      v-model="single_date.allDay"
                      name="single_date_allDay"
                      >All Day</vs-checkbox
                    >
                  </div>
                  <span
                    class="text-danger text-sm mt-15"
                    v-show="errors.has('single_date_date')"
                    >{{ errors.first("single_date_date") }}</span
                  >
                  <div class="vx-row mt-10" v-if="!single_date.allDay">
                    <div class="vx-col sm:w-1/6 w-full">
                      <span>Choose Time</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                      <div class="vx-col w-full mb-5">
                        <span>Start</span>
                      </div>
                      <flat-pickr
                        :config="configStartTimePicker"
                        v-model="single_date.start_time"
                        placeholder="Choose Date Time"
                      />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                      <div class="vx-col w-full mb-5">
                        <span>End</span>
                      </div>
                      <flat-pickr
                        :config="configEndTimePicker"
                        v-model="single_date.end_time"
                        placeholder="Choose Date Time"
                      />
                    </div>
                  </div>
                  <span
                    class="text-danger text-sm mt-5"
                    v-if="start_end_time"
                    >{{ start_end_time }}</span
                  >
                  <div
                    class="vx-col mt-20"
                    vs-justify="center"
                    vs-align="center"
                  >
                    <vs-button @click="validateBeforeSingleDateSubmit()"
                      >Submit</vs-button
                    >
                  </div>
                </div>
              </div>
            </form>
            <form>
              <div
                class="vx-row pb-20"
                v-if="schedule_type == 'continuous_date'"
              >
                <div class="vx-col sm:w-1/5 w-full">
                  <h5>Schedule Continuos Date</h5>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vs-radio
                      v-model="continuous_date.availability"
                      vs-value="available"
                      class="mr-5"
                      >Available</vs-radio
                    >
                    <vs-radio
                      v-model="continuous_date.availability"
                      vs-value="not-available"
                    >
                      Not Available</vs-radio
                    >
                  </div>

                  <div class="vx-col sm:w-1/2 w-full mt-10">
                    <div class="vx-col w-full mb-5">
                      <span>Start</span>
                    </div>
                    <flat-pickr
                      :config="configDateTimePicker"
                      v-model="continuous_date.start"
                      placeholder="Choose Date Time"
                      name="continuous_date_start"
                      v-validate="'required'"
                      data-vv-as=" Start Date"
                    />
                    <div class="vx-col w-full mb-5">
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('continuous_date_start')"
                        >{{ errors.first("continuous_date_start") }}</span
                      >
                    </div>
                  </div>

                  <div class="vx-col sm:w-1/2 w-full mt-10">
                    <div class="vx-col w-full mb-5">
                      <span>End</span>
                    </div>
                    <flat-pickr
                      :config="configDateTimePicker"
                      v-model="continuous_date.end"
                      placeholder="Choose Date Time"
                      name="continuous_date_end"
                      v-validate="'required'"
                      data-vv-as="End Date"
                    />
                    <div class="vx-col w-full mb-5">
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('continuous_date_end')"
                        >{{ errors.first("continuous_date_end") }}</span
                      >
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mt-20">
                    <vs-button @click="validateBeforeContinuousDateSubmit()"
                      >Submit</vs-button
                    >
                  </div>
                </div>
              </div>
            </form>
        <form>

            <div
              v-if="schedule_type == 'multiple_non_continuous_date'"
              class="ml-20"
            >
              <div class="vx-col sm:w-1/5 w-full mb-5">
                <h5>Schedule Multiple Non Continuous Date</h5>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="vx-col w-full">
                    <vs-radio
                      v-model="multiple_non_continuous_availabilty"
                      vs-value="available"
                      class="mr-5"
                      >Available</vs-radio
                    >
                    <vs-radio
                      v-model="multiple_non_continuous_availabilty"
                      vs-value="not-available"
                    >
                      Not Available</vs-radio
                    >
                  </div>
                </div>
              </div>

              <div
                class="vx-row mb-5 "
                v-for="(mncd, index) in multiple_non_continuous_date"
              >
                <template>
                  <div class="vx-col sm:w-1/5 w-full mt-5">
                    <div class="vx-col w-full mb-5">
                      <span>Start</span>
                    </div>
                    <flat-pickr
                      :config="configDateTimePicker"
                      v-model="mncd.start"
                      placeholder="Choose Date Time"
                    />
                  </div>

                  <div class="vx-col sm:w-1/5 w-full mt-5">
                    <div class="vx-col w-full mb-5">
                      <span>End</span>
                    </div>
                    <flat-pickr
                      :config="configDateTimePicker"
                      v-model="mncd.end"
                      placeholder="Choose Date Time"
                    />
                  </div>
                  <feather-icon
                  icon="XIcon"
                  svgClasses="h-4 w-4"
                  v-on:click="removemncd(index)"
                />
                </template>
              </div>

              <div class="vx-row mb-5">
                <div class="vx-col sm:w-1/5 w-full mt-10">
                  <vs-button @click="validateBeforeMultipleNonContinuousSubmit()"
                    >Submit</vs-button
                  >
                </div>
                <div class="vx-col sm:w-1/5 w-full mt-10">
                  <vs-button color="danger" @click="selectAnotherDate()"
                    >Schedule Another Date</vs-button
                  >
                </div>
              </div>
            </div>
                    </form>

          </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import moduleCalendarManagement from "@/store/calendar-management/moduleCalendarManagement.js";
import { DateTime } from "luxon";
import moment from "moment";
import { RefreshCcwIcon } from "vue-feather-icons";

export default {
  data() {
    return {
      start_end_time: null,
      user_id: null,
      user_role: null,
      configdatePicker: {
        dateFormat: "Y-m-d",
        disable: [
          function(selectedDate) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return selectedDate < today; // return true to disable
          }
        ]
      },
      configDateTimePicker: {
        time_24hr: true,
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        disable: [
          function(selectedDate) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return selectedDate < today; // return true to disable
          }
        ]
      },
      configStartTimePicker: {
        time_24hr: true,
        enableTime: true,
        enableSeconds: false,
        noCalendar: true
      },
      configEndTimePicker: {
        time_24hr: true,
        enableTime: true,
        enableSeconds: false,
        noCalendar: true
      },
      schedule_type: null,
      single_date: {
        availability: "not-available",
        date: moment(new Date()).format('YYYY-MM-DD'),
        start_time: moment(new Date()).format('HH:mm'),
        end_time: moment(new Date()).format('HH:mm'),
        allDay: false,
        schedule_type: "single_date"
      },
      continuous_date: {
        availability: "not-available",
        start: moment(new Date()).format('YYYY-MM-DD HH:mm'),
        end: moment(new Date()).format('YYYY-MM-DD HH:mm'),
        schedule_type: "continuous_date",
        allDay: false
      },
      multiple_non_continuous_availabilty: "not-available",
      multiple_non_continuous_date: [
        {
          id:0,
          start: moment(new Date()).format('YYYY-MM-DD HH:mm'),
        end: moment(new Date()).format('YYYY-MM-DD HH:mm'),
          schedule_type: "multiple_non_continuous_date",
          allDay: false,
        }
      ],
      counter:0
    };
  },
  components: {
    flatPickr
  },
  created() {
    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    if (!moduleCalendarManagement.isRegistered) {
      this.$store.registerModule(
        "calendarManagement",
        moduleCalendarManagement
      );
      moduleCalendarManagement.isRegistered = true;
    }

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];

    this.user_role = userInfo["userRole"];

    if (this.user_role == 'Client Administrator' && this.user_role == 'Client'){
      this.$router.replace("/unauthorized")
    }
  },
  mounted() {
    // this.fetchDefaultSettings();
  },
  methods: {
    removemncd(index){
      this.multiple_non_continuous_date.splice(index,1);
    },
    selectAnotherDate() {
      this.multiple_non_continuous_date.push({
        id:++this.counter,
        start: null,
        end: null,
        schedule_type: "multiple_non_continuous_date",
        allDay: false
      });
      this.counter++
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addScheduleToDB(scheduleEvents) {
      this.$store
        .dispatch("calendarManagement/setScheduleAvailabilty", scheduleEvents)
        .then(res => {
          // if (res.data.status == "fail") {
          //   this.$vs.notify({
          //     color: "danger",
          //     title: "Schedule Availabilty",
          //     text: res.data.message
          //   });
          // } else {
          //   this.$vs.notify({
          //     color: "success",
          //     title: "Schedule Availabilty",
          //     text: res.data.message
          //   });
          // }


          // this.$router.go();
          this.$router.push("/calendar");
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    validateBeforeSingleDateSubmit() {
      let self = this;
      self.start_end_time = null;
      self.$validator.validateAll().then(result => {
        if (result) {
          if (
            (self.single_date.start_time == null ||
              self.single_date.end_time == null) &&
            self.single_date.allDay == false
          ) {
            self.start_end_time = "Please choose time";
            return;
          }
          if (!self.single_date.allDay) {
            let startTime = self.single_date.start_time.split(":");
            let endTime = self.single_date.end_time.split(":");
            let strt = parseInt(
              startTime[0] * 3600 + startTime[1] * 60 + startTime[0]
            );
            let ended = parseInt(
              endTime[0] * 3600 + endTime[1] * 60 + endTime[0]
            );

            if (strt > ended || strt == ended) {
              self.start_end_time =
                "End Time should be greater than start time";
              return;
            }
          }

          let newSheduleEventObj = {};
          newSheduleEventObj.schedule_type = self.single_date.schedule_type;
          newSheduleEventObj.available = self.single_date.availability;
          newSheduleEventObj.allDay = self.single_date.allDay;
          if (!self.single_date.allDay) {
            newSheduleEventObj.start_time = self.single_date.start_time;
            newSheduleEventObj.end_time = self.single_date.end_time;
          } else {
            newSheduleEventObj.start_time = "00:00";
            newSheduleEventObj.end_time = "00:00";
          }

          newSheduleEventObj.start_date = moment(self.single_date.date).format(
            "YYYY-MM-DD"
          );
          newSheduleEventObj.end_date = moment(self.single_date.date).format(
            "YYYY-MM-DD"
          );
          newSheduleEventObj.user_id = this.user_id;

           self.getAvalabileTimeSlots(newSheduleEventObj);

        
        }
      });
    },
    getAvalabileTimeSlots(scheduleEvents) {
      let self = this;
      this.$store
        .dispatch(
          "calendarManagement/getAvalabileTimeSlots",
          scheduleEvents
        )
        .then(res => {

          let response_data = res.data;

          console.log("getAvalabileTimeSlots" , response_data);


          if (response_data.length > 0) {

            self.$vs.notify({
              color: "danger",
              title: "Default Settings",
              text: "The time slot is already added for the selected date. Please update the time slot."
            });
            return false
          }else{

            self.overridePreviousAllDaySchedule(scheduleEvents);
            self.addScheduleToDB(scheduleEvents);

          }


          
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getDaysBetweenDates(startDate, endDate) {
      var now = startDate.clone(),
        dates = [];

      while (now.isSameOrBefore(endDate)) {
        dates.push(now.format("YYYY-MM-DD"));
        now.add(1, "days");
      }
      return dates;
    },
    validateBeforeMultipleNonContinuousSubmit(){
       let self = this;

       self.multiple_non_continuous_date.forEach((ele) => {
         const range = this.getDaysBetweenDates(
            moment(ele.start),
            moment(ele.end)
          );
          range.forEach((element, index) => {
            var overrideObj = {}
            overrideObj.start_date = element
            overrideObj.end_date = element
            overrideObj.user_id = self.user_id;
            self.overridePreviousAllDaySchedule(overrideObj);

            let newSheduleEventObj = {};
            if (index === range.length - 1) {
              newSheduleEventObj.end_time = moment(
                ele.end
              ).format("HH:mm");
            } else {
              newSheduleEventObj.end_time = "24:00";
            }

            if (index == 0) {
              newSheduleEventObj.start_time = moment(
                ele.start
              ).format("HH:mm");
            } else {
              newSheduleEventObj.start_time = "00:00";
            }
            newSheduleEventObj.allDay = false;
            newSheduleEventObj.start_date = element;
            newSheduleEventObj.end_date = element;
            newSheduleEventObj.schedule_type =
              ele.schedule_type;
            newSheduleEventObj.available = self.multiple_non_continuous_availabilty;
            newSheduleEventObj.user_id = self.user_id;

            if (
              newSheduleEventObj.start_time == "00:00" &&
              newSheduleEventObj.end_time == "24:00"
            ) {
              newSheduleEventObj.allDay = true;
            } else {
              newSheduleEventObj.allDay = false;
            }
            self.addScheduleToDB(newSheduleEventObj);
          });

       })
          
    },
    validateBeforeContinuousDateSubmit() {
      let self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          const range = this.getDaysBetweenDates(
            moment(self.continuous_date.start),
            moment(self.continuous_date.end)
          );


           console.log("Range" , range);


          range.forEach((element, index) => {

            var overrideObj = {}
            overrideObj.start_date = element
            overrideObj.end_date = element
            overrideObj.user_id = self.user_id;
            self.overridePreviousAllDaySchedule(overrideObj);

            let newSheduleEventObj = {};
            if (index === range.length - 1) {
              newSheduleEventObj.end_time = moment(
                self.continuous_date.end
              ).format("HH:mm");
            } else {
              newSheduleEventObj.end_time = "24:00";
            }

            if (index == 0) {
              newSheduleEventObj.start_time = moment(
                self.continuous_date.start
              ).format("HH:mm");
            } else {
              newSheduleEventObj.start_time = "00:00";
            }
            newSheduleEventObj.allDay = false;
            newSheduleEventObj.start_date = element;
            newSheduleEventObj.end_date = element;
            newSheduleEventObj.schedule_type =
              self.continuous_date.schedule_type;
            newSheduleEventObj.available = self.continuous_date.availability;
            newSheduleEventObj.user_id = self.user_id;

            if (
              newSheduleEventObj.start_time == "00:00" &&
              newSheduleEventObj.end_time == "24:00"
            ) {
              newSheduleEventObj.allDay = true;
            } else {
              newSheduleEventObj.allDay = false;
            }
            self.addScheduleToDB(newSheduleEventObj);
          });
        }
      });
    },
    overridePreviousAllDaySchedule(scheduleEvents) {
      this.$store
        .dispatch(
          "calendarManagement/overridePreviousAllDayScheduled",
          scheduleEvents
        )
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
    // fetchDefaultSettings() {
    //   this.$store
    //     .dispatch(
    //       "calendarManagement/fetchDefaultSettings",
    //       this.work_availability.user_id
    //     )
    //     .then(res => {
    //       if (res) {
    //         if (res.data != null) {
    //           this.new_default_settings = false;
    //           this.work_availability = res.data;
    //           if (this.work_availability.available) {
    //             this.work_availability.available = "available";
    //           } else {
    //             this.work_availability.available = "not-available";
    //           }
    //           let stored_dow = this.work_availability.dow.split(
    //             ","
    //           );
    //           this.work_availability.dow = [
    //             {
    //               name: "Sunday",
    //               slug: "0",
    //               checked: false
    //             },
    //             {
    //               name: "Monday",
    //               slug: "1",
    //               checked: false
    //             },
    //             {
    //               name: "Tuesday",
    //               slug: "2",
    //               checked: false
    //             },
    //             {
    //               name: "Wednesday",
    //               slug: "3",
    //               checked: false
    //             },
    //             {
    //               name: "Thursday",
    //               slug: "4",
    //               checked: false
    //             },
    //             {
    //               name: "Friday",
    //               slug: "5",
    //               checked: false
    //             },
    //             {
    //               name: "Saturday",
    //               slug: "6",
    //               checked: false
    //             }
    //           ];
    //           this.work_availability.dow.forEach(element => {
    //             if (stored_dow.includes(element.slug)) {
    //               element.checked = true;
    //             }
    //           });
    //         } else {
    //           this.new_default_settings = true;
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       if (err.response.status === 404) {
    //         console.log(err);
    //       }
    //       console.error(err);
    //     });
    // }
  }
};
</script>
